<template>
	<div id="onlineReservationBox">
		<div class="ml-8">
			<div v-if="widgetType.hasHeader" id="title-div">
				<span class="title">Online Reservation</span>
				<br>
				<span class="subtitle">Confirm your booking and check for hotels flexible rates.</span>
			</div>
			<div id="search-box-div">
				<b-form id="search-form" @submit.prevent="callMakeYourBookings()">
					<b-row>
						<b-col class="destination-col">
							<label v-if="widgetType.hasLabels">City or Hotel Name</label>
							<multiselect class="multiselect-sm" v-model="hotelsFilter.destination" :options="groupedDestinationsResult"
								group-values="destinations" group-label="type" @search-change="searchDestinations" track-by="id"
								label="name" placeholder="CITY OR HOTEL NAME" :max-height="180" select-label="" required>
								<span slot="noResult">{{ translation.destinationNotFound }}</span>
							</multiselect>
						</b-col>
						<b-col class="checkin-col">
							<label v-if="widgetType.hasLabels">Check in</label>
							<b-form-datepicker v-model="hotelsFilter.checkin" :min="new Date()" :hide-header="true"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder="CHECK IN"
							:required="true" :label-help="null" size="sm" required></b-form-datepicker>
						</b-col>
						<b-col class="checkout-col">
							<label v-if="widgetType.hasLabels">Check out</label>
							<b-form-datepicker v-model="hotelsFilter.checkout" :min="hotelsFilter.checkin" :hide-header="true"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder="CHECK OUT"
							:required="true" :label-help="null" size="sm" required></b-form-datepicker>
						</b-col>
					</b-row>
					<b-row>
						<b-col class="roomsQty-col">
							<span>ROOMS</span>
							<b-form-select v-model="hotelsFilter.roomsQty" :options="Array.from({ length: 5 }, (_, i) => i + 1)"
							required size="sm"></b-form-select>
						</b-col>
						<b-col class="adultsQty-col">
							<span>ADULTS</span>
							<b-form-select v-model="hotelsFilter.adultsQty" :options="Array.from({ length: 4 }, (_, i) => i + 1)"
							required size="sm"></b-form-select>
						</b-col>
						<b-col class="chdNumber-col">
							<span>CHILDREN</span>
							<b-form-select v-model="hotelsFilter.chdNumber" @change="childrenChange($event)"
								:options="Array.from({ length: 3 }, (_, i) => i)" size="sm"></b-form-select>
						</b-col>
						<b-col v-for="(age, index) in hotelsFilter.chdAges" :key="index" class="chd-ages">
								<span>AGE</span>
								<b-form-select v-model="hotelsFilter.chdAges[index]"
								:options="Array.from({ length: 12 }, (_, i) => i)" size="sm"></b-form-select>
						</b-col>

					</b-row>
					<b-row>
						<b-col>
							<b-button id="btnGo" type="submit" size="sm"></b-button>
						</b-col>
					</b-row>
				</b-form>
			</div>
		</div>
	</div>
</template>
<script>
import DestinationService from '../../services/DestinationService';
import LoginService from '../../services/LoginService';
import DestinationType from '../../enums/DestinationType';
import WidgetType from '../../enums/WidgetType';
import translationEn from '../../assets/translationEn';
import { groupBy } from 'lodash';

export default {
	props: ["type", "username", "password"],
	data() {
		return {
			loginService: new LoginService(),
			destinationService: null,
			hotelsFilter: {
				roomsQty: 1,
				adultsQty: 2,
				chdAges: [],
				chdNumber: 0
			},
			destinations: null,
			widgetType: {}
		}
	},
	mounted() {
		if(this.username && this.password)
			this.loginService.login({ login: this.username, password: this.password })
			.then((res) => {
				this.$store.dispatch("login", { token: res.data.key });
				this.$store.dispatch("loadUserInfo", res.data);
				this.destinationService = new DestinationService(JSON.parse(localStorage.getItem('user')));
				this.widgetType = Object.values(WidgetType).find(type => type.name == this.type);
				this.addDynamicCss();
			})
			.catch((error) =>
				this.$router.push('/login')
			);
	},
	computed: {
		translation() {
			return translationEn.searchArea;
		},
		groupedDestinationsResult() {
			var groupedDestinationsResult = [];
			for (const [key, value] of Object.entries(groupBy(this.destinations, 'type'))) {
				groupedDestinationsResult.push({type: this.translation[DestinationType[key].translationField], destinations: value});
			}
			return groupedDestinationsResult;
		},
	},
	methods: {
		searchDestinations(name) {
			if (name.length >= 3) {
				this.destinationService.getHotelsAndCitiesByName(name)
					.then((res) => this.destinations = res.data.destinations);
			}
		},
		validate() {
			var invalidFields = [];
			if(!this.hotelsFilter.destination)
				invalidFields.push(this.translation.destination);
			if(!this.hotelsFilter.checkin)
				invalidFields.push(this.translation.checkin);
			if(!this.hotelsFilter.checkout)
				invalidFields.push(this.translation.checkout);

			if(invalidFields.length > 0) {
				this.$store.dispatch("showAlert", {
					message: this.translation.invalidFields + invalidFields.join(', '),
					code: 0,
					style: "warning"
				});
				return false;
			}
			return true;
		},
		callMakeYourBookings() {
			if(!this.validate()) return false;
			document.getElementsByTagName("head")[0].removeChild(document.getElementById("dynamic-stylesheet"));
      this.$router.push({name:'search', params: {widgetHotelsFilter: this.hotelsFilter}});
		},
		childrenChange(e) {
			if (e == 0)
				this.hotelsFilter.chdAges = [];
			else
				this.hotelsFilter.chdAges = Array(e);
		},
		addDynamicCss() {
			var element = document.createElement("link");
    	element.setAttribute("id", "dynamic-stylesheet");
    	element.setAttribute("rel", "stylesheet");
    	element.setAttribute("type", "text/css");
    	element.setAttribute("href", '/src/assets/css/widget-'+ this.type +'.css');
    	document.getElementsByTagName("head")[0].appendChild(element);
		}
	},
}
</script>
<style>
.multiselect-sm {
	font-size: 13px !important;

	.multiselect__select {
		font-size: 13px !important;
	}

	.multiselect__select {
		height: 31px !important;
	}

	.multiselect__placeholder {
    margin-bottom: 4px !important;
	}

	.multiselect__tags {
		min-height: 0px !important;
    padding: 4px 40px 0 8px !important;
	}

	.multiselect__content-wrapper {
		max-height: 180px !important;
	}
}

.dropdown-menu {
	max-height: 200px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ReservationWidget.vue